<template>
    <div class="frn-tab">
        <a-card :bordered="false" class="frn-title-card">
            <div class="frn-hd">
                <div>
                    <h2>Fornecedores</h2>
                    <div class="frn-sub">Fornecedores convidados para esta cotação</div>
                </div>
                <div class="frn-actions">
                    <a-button @click="$emit('toggle-totalizadores')">
                        <i class="fa-solid fa-calculator"></i>
                        {{ show_totalizadores ? "Ocultar Totalizadores" : "Mostrar Totalizadores" }}
                    </a-button>

                    <a-dropdown :trigger="['click']">
                        <a-button>
                            Exportar
                            <a-icon type="down" />
                        </a-button>

                        <a-menu slot="overlay">

                            <a-menu-item @click="$emit('export', 'excel')">
                                Exportar Excel
                            </a-menu-item>

                            <a-menu-item @click="$emit('export', 'pdf')">
                                Exportar PDF
                            </a-menu-item>

                        </a-menu>
                    </a-dropdown>

                    <a-button type="primary" @click="$emit('add-fornecedor')">
                        <span class="material-icons-outlined frn-btn-icon">add</span>
                        Adicionar fornecedor
                    </a-button>
                </div>
            </div>

            <div class="cmp-filterbar">
                <div class="cmp-frow">

                <a-select
                    class="cmp-ff"
                    placeholder="Selecione os status"
                    mode="multiple"
                    :value="filters.status"
                    allow-clear
                    show-search
                    option-filter-prop="label"
                    :options="status_options.map(item => ({
                        label: item.label,
                        value: item.value,
                    }))"
                    @change="
                        (value) =>
                            $emit('update-filter', {
                                key: 'status',
                                value: value,
                            })
                    "
                />


                <a-checkbox
                    :checked="filters.has_offered_products"
                    @change="
                        (e) =>
                            $emit('update-filter', {
                                key: 'has_offered_products',
                                value: e.target.checked,
                            })
                    "
                >
                    Produtos ofertados
                </a-checkbox>


                <a-checkbox
                    :checked="filters.has_previous_offered_products"
                    @change="
                        (e) =>
                            $emit('update-filter', {
                                key: 'has_previous_offered_products',
                                value: e.target.checked,
                            })
                    "
                >
                    Produtos ofertados anteriormente
                </a-checkbox>


                <div class="cmp-frow-actions">
                    <a-button type="danger" @click="$emit('clear-filters')">
                        <i class="fa-solid fa-filter-circle-xmark"></i> Limpar
                    </a-button>

                    <a-button
                        type="primary"
                        icon="search"
                        @click="$emit('search')"
                    >
                        Filtrar
                    </a-button>
                </div>

                </div>
            </div>
        </a-card>

        <div class="frn-stats">
            <dashboard-stats :items="dashboardCards" :show-totalizadores="show_totalizadores" dynamic-width />
        </div>

        <a-card :bordered="false" class="frn-card">
            <a-table
                size="small"
                :columns="columns"
                :data-source="providers"
                :loading="is_loading"
                :pagination="pagination"
                @change="handleTableChange"
                row-key="id_vendedor"
                :locale="{ emptyText: 'Nenhum fornecedor convidado para esta cotação.' }"
            >
                <template slot="fornecedor" slot-scope="text, record">
                    <div class="frn-strong">{{ record.fornecedor_nome || "-" }}</div>
                </template>
                <template slot="contato" slot-scope="text, record">
                    <div class="frn-contact" v-if="record.vendedor_email || record.vendedor_telefone">
                        <span v-if="record.vendedor_email">{{ record.vendedor_email }}</span>
                        <cc-whatsapp v-if="record.vendedor_telefone" :phone="record.vendedor_telefone" />
                    </div>
                    <span v-else>-</span>
                </template>
                <template slot="entrega" slot-scope="text, record">
                    {{ record.entrega && record.entrega.date ? formatDate(record.entrega.date) : "-" }}
                </template>
                <template slot="minBilling" slot-scope="text, record">{{ minBilling(record) }}</template>
                <template slot="participacao" slot-scope="text, record">
                    <span v-if="record.participation" :class="participationClass(record.participation)">
                        {{ (record.participation * 100).toFixed(2) }}%
                    </span>
                    <span v-else>-</span>
                </template>
                <template slot="status" slot-scope="text, record">
                    <span class="frn-tag" :class="statusClass(record.status)">
                        <span class="material-icons-outlined">{{ statusIcon(record.status) }}</span>
                        {{ statusLabel(record.status) }}
                    </span>
                </template>
                <template slot="actions" slot-scope="text, record">
                    <ActionMenu :actions="providerActions(record)" />
                </template>
            </a-table>
        </a-card>
    </div>
</template>

<script>
import currencyPrecision from "@/mixins/currencyPrecision";
import ActionMenu from "@/components/popovers/action-menu.popover.vue";
import StatsCards from "@/components/cliente/monitors/StatsCards.vue";

const STATUS_LABEL = {
    NOT_TYPED: "Não Digitada",
    TYPED: "Digitada",
    FROZEN: "Congelada",
    ORDERED: "Pedido Gerado",
    NOT_OFFERED: "Sem Oferta",
    NOT_ORDERED: "Sem Pedido",
};
const STATUS_ICON = {
    NOT_TYPED: "edit_off",
    TYPED: "edit_note",
    FROZEN: "ac_unit",
    ORDERED: "shopping_bag",
    NOT_OFFERED: "block",
    NOT_ORDERED: "remove_shopping_cart",
};
const STATUS_CLASS = {
    NOT_TYPED: "flat",
    TYPED: "info",
    FROZEN: "ice",
    ORDERED: "best",
    NOT_OFFERED: "error",
    NOT_ORDERED: "warn",
};

export default {
    name: "FornecedoresTab",
    mixins: [currencyPrecision],
    components: { ActionMenu, "dashboard-stats": StatsCards },
    props: {
        providers: { type: Array, default: () => [] },
        is_loading: { type: Boolean, default: false },
        filters: { type: Object, required: true },
        status_options: { type: Array, required: true},
        pagination: {
            type: Object,
            required: true,
        },
        sort: {
            type: Object,
            required: true,
        },
        can_send_whatsapp: {
            type: Boolean,
            default: false,
        },
        id: {
            type: [Number, String],
            required: true
        },
        engagedProvidersCount: {
            type: Number,
            default: 0,
        },
        summary: {
            type: Object,
            default: null,
        },
        totalWithoutFilters: {
            type: Number,
            default: 0,
        },
        show_totalizadores: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        dashboardCards() {
            // LEGACY: kyojin sem /competitors/summary. Remover quando o back com summary estiver em produção.
            if (!this.summary) {
                return [
                    { key: "engajados", title: "Fornecedores engajados", icon: "storefront", value: this.engagedProvidersCount, borderColor: "#1890ff" },
                    { key: "registros", title: "Registros", icon: "fact_check", value: this.pagination.total, borderColor: "#722ed1" },
                ];
            }

            const s = this.summary;
            const pct = (n) => (s.total ? Math.round((n / s.total) * 100) : 0);
            const avgBilling = (s.avg_minimum_billing || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            const avgParticipation = ((s.avg_participation || 0) * 100).toFixed(1);

            return [
                { key: "fornecedores", title: "Fornecedores", icon: "storefront", value: s.total, footerText: `de ${this.totalWithoutFilters} convidados`, borderColor: "#722ed1" },
                { key: "engajados", title: "Engajados", icon: "handshake", value: s.engaged, footerText: `${pct(s.engaged)}% dos fornecedores`, borderColor: "#1890ff" },
                { key: "visualizaram", title: "Visualizaram", icon: "visibility", value: s.viewed, footerText: `${pct(s.viewed)}% abriram a cotação`, borderColor: "#13c2c2" },
                { key: "digitados", title: "Digitados", icon: "edit_note", value: s.typed, footerText: `${s.frozen} congeladas`, borderColor: "#52c41a" },
                { key: "nao_digitados", title: "Não digitados", icon: "edit_off", value: s.not_typed, footerText: `${pct(s.not_typed)}% dos fornecedores`, borderColor: "#8c8c8c" },
                { key: "sem_oferta", title: "Sem oferta", icon: "block", value: s.not_offered, footerText: `${pct(s.not_offered)}% dos fornecedores`, borderColor: "#ff4d4f" },
                { key: "pedido_gerado", title: "Pedido gerado", icon: "shopping_bag", value: s.ordered, footerText: `${s.not_ordered} sem pedido`, borderColor: "#FF5722" },
                { key: "produtos_ofertados", title: "Produtos ofertados", icon: "inventory_2", value: s.offered_products, footerText: `Part. média ${avgParticipation}% · Fat. mín. médio R$ ${avgBilling}`, borderColor: "#faad14" },
            ];
        },
        columns() {
            return [
                { 
                    title: "Fornecedor", 
                    key: "fornecedor",
                    columnKey: "provider_name",
                    scopedSlots: { customRender: "fornecedor" },
                    sorter: true,
                    sortOrder: this.sort.field === "provider_name"
                        ? this.sort.order
                        : false,
                },
                { title: "Vendedor", dataIndex: "vendedor_nome" },
                { title: "Contato", key: "contato", scopedSlots: { customRender: "contato" } },
                { title: "Cond. pagamento", customRender: (text, record) => (record.entrega ? record.entrega.form : "-") },
                { title: "Entrega prevista", key: "entrega", scopedSlots: { customRender: "entrega" } },
                { title: "Faturamento mín.", key: "minBilling", align: "right", scopedSlots: { customRender: "minBilling" } },
                { 
                    title: "Participação", 
                    key: "participacao", 
                    columnKey: "participation", 
                    align: "right", 
                    scopedSlots: { customRender: "participacao" },
                    sorter: true,
                    sortOrder: this.sort.field === "participation"
                        ? this.sort.order
                        : false,
                },
                { title: "Status", key: "status", align: "center", scopedSlots: { customRender: "status" } },
                {
                    title: "Produtos ofertados",
                    align: "left",
                    children: [
                        {
                            title: "Atual",
                            dataIndex: "offered_products_count",
                            align: "center",
                            customRender: (text) => (text != null ? text : "-"),
                        },
                        {
                            title: "Anterior",
                            dataIndex: "prev_offered_products_count",
                            align: "center",
                            customRender: (text) => (text != null ? text : "-"),
                        },
                    ],
                },
                {
                    title: "Observação",
                    align: "center",
                    customRender: (text, record) =>
                        record.entrega && record.entrega.obs
                            ? record.entrega.obs
                            : "-",
                },
                {
                    title: "Visualizado em",
                    align: "center",
                    customRender: (text, record) => {
                        return record.viewed_at
                            ? this.$moment(record.viewed_at).format("DD/MM/YYYY HH:mm")
                            : "-";
                    },
                },
                {
                    title: "Ações",
                    key: "actions",
                    align: "center",
                    scopedSlots: { customRender: "actions" },
                }
            ];
        },
    },
    methods: {
        providerActions(record) {
            return [
                {
                    label: "Enviar WhatsApp com link",
                    icon: "fab fa-whatsapp",
                    iconClass: "action-success",
                    visible: this.can_send_whatsapp,
                    onClick: () => this.openWhatsapp(record),
                },
            ];
        },
        openWhatsapp(item) {
            const numero = item.vendedor_telefone
            const texto = `Segue o link para responder à cotação: https://novo.fornecedor.clubdacotacao.com.br/cotacoes/${this.id}/vendedor/${item.id_vendedor}?token=${item.auth_token}`

            const url = `https://api.whatsapp.com/send?phone=55${numero}&text=${encodeURIComponent(texto)}`
            window.open(url, '_blank')
        },
        handleTableChange(pagination, filters, sorter) {
            this.$emit("search", {
                pagination,
                sorter: {
                    field: sorter.order
                        ? sorter.column.columnKey
                        : "provider_name",
                    order: sorter.order || "ascend",
                },
            });
        },
        statusLabel(status) {
            return STATUS_LABEL[status] || "--";
        },
        statusIcon(status) {
            return STATUS_ICON[status] || "help_outline";
        },
        statusClass(status) {
            return STATUS_CLASS[status] || "flat";
        },
        participationClass(value) {
            if (value <= 0.3) return "frn-part low";
            if (value >= 0.7) return "frn-part high";
            return "frn-part mid";
        },
        formatDate(date) {
            return date.split("-")[2] + "/" + date.split("-")[1] + "/" + date.split("-")[0];
        },
        minBilling(item) {
            if (!item.entrega || !item.entrega.minimum_billing) return "-";
            return this.$options.filters.customCurrency(item.entrega.minimum_billing);
        },
    },
};
</script>

<style lang="scss" scoped>
.frn-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}
.frn-btn-icon {
    font-size: 16px;
    vertical-align: -3px;
}
.frn-stats {
    margin-bottom: 10px;
    padding: 0 6px;
    overflow: hidden;
}
.cmp-filterbar {
    padding: 16px 0 0;
}
.cmp-frow {
    display: flex;
    gap: 8px;
    align-items: flex-end;
    flex-wrap: wrap;
}
.cmp-frow-actions {
    display: flex;
    gap: 8px;
    margin-left: auto;
}
.cmp-ff {
    flex: 1 1 160px;
    max-width: 300px;
}
.cmp-ff-search {
    max-width: 260px;
}
.cmp-fbtn {
    height: 40px;
    padding: 0 16px;
    border-radius: 6px;
    border: 1px solid #d9d9d9;
    background: #fff;
    color: #434343;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
        border-color: var(--pri);
        color: var(--pri);
    }
    &.on {
        background: var(--pri-bg);
        color: var(--pri);
        border-color: var(--pri);
    }
    &.cmp-fbtn-primary {
        background: var(--pri);
        border-color: var(--pri);
        color: #fff;
        font-weight: 600;
    }
    &.cmp-fbtn-clear {
        color: #8c8c8c;
    }
    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }
}
.frn-tab {
    background-color: #f5f5f5;
}
.frn-title-card {
    width: 100%;
    margin-bottom: 10px;
}
.frn-hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;

    h2 {
        font-size: 16px;
        font-weight: 600;
        color: #262626;
    }
}
.frn-sub {
    font-size: 13px;
    color: #8c8c8c;
    margin-top: 2px;
}
.frn-card {
    --pri: var(--primary-color);
    width: 100%;
    overflow: hidden;

    ::v-deep(.ant-card-body) {
        width: 100%;
        padding: 0 !important;
        margin: 0 !important;
    }
    ::v-deep(.ant-table-wrapper),
    ::v-deep(.ant-table),
    ::v-deep(.ant-table-content),
    ::v-deep(table) {
        width: 100%;
        margin: 0 !important;
    }
}
.frn-strong {
    font-weight: 600;
    color: #262626;
}
.frn-contact {
    display: flex;
    flex-direction: column;
    gap: 2px;
    font-size: 13px;
}
.frn-part {
    font-weight: 600;

    &.low {
        color: #cf1322;
    }
    &.mid {
        color: #d46b08;
    }
    &.high {
        color: #389e0d;
    }
}
.frn-tag {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    font-weight: 600;
    padding: 2px 10px;
    border-radius: 999px;
    white-space: nowrap;

    .material-icons-outlined {
        font-size: 14px;
    }
    &.flat {
        background: #f5f5f5;
        color: #8c8c8c;
    }
    &.info {
        background: #e6f4ff;
        color: #0958d9;
        border: 1px solid #91caff;
    }
    &.ice {
        background: #e6fffb;
        color: #08979c;
        border: 1px solid #87e8de;
    }
    &.best {
        background: #f6ffed;
        color: #389e0d;
        border: 1px solid #b7eb8f;
    }
    &.error {
        background: #fff1f0;
        color: #cf1322;
        border: 1px solid #ffccc7;
    }
    &.warn {
        background: #fff7e6;
        color: #d46b08;
        border: 1px solid #ffd591;
    }
}
</style>
